export default "__VITE_ASSET__DkLlyaDG__"